// The Top Level Domain
//
export const tld = process.env.REACT_APP_HOST
//
//
// -----------------------------
// Auth Api Key => key based
// -----------------------------
//
export const config = { headers: { "X-Api-Key": `${process.env.REACT_APP_API_KEY}` } }
//
//
//